import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PoModule } from '@po-ui/ng-components';
import { ConciliacaoFornecedoresComponent } from './conciliacao-fornecedores.component';

@NgModule({
  declarations: [ConciliacaoFornecedoresComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    PoModule
  ]
})
export class ConciliacaoFornecedoresModule { }
